import React, { ReactNode, ReactElement } from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux-dynamic-modules';
import { getSagaExtension } from 'redux-dynamic-modules-saga';

const store = createStore({ extensions: [getSagaExtension()] });

export interface IStoreProviderProps {
  children: ReactNode;
}

const StoreProvider = ({ children }: IStoreProviderProps): ReactElement => (
  <Provider store={store}>
    {children}
  </Provider>
);

export default StoreProvider;
